import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-403c5bc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "threshold-filter-options animated-fast" }
const _hoisted_2 = { class: "p-title" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "filter-options" }
const _hoisted_5 = {
  key: 0,
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-bottom":"8px"} }, null, -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { style: {"display":"flex","justify-content":"center","align-items":"center","flex-direction":"column","padding-top":"5px"} }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "range-number-inputs"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-sync" }, null, -1))
const _hoisted_13 = {
  key: 1,
  class: "range-number-inputs"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-sync" }, null, -1))
const _hoisted_15 = {
  key: 2,
  class: "range-number-inputs"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-sync" }, null, -1))
const _hoisted_17 = {
  key: 3,
  class: "range-number-inputs"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-sync" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_spinner = _resolveComponent("imdex-spinner")!
  const _component_imdex_select = _resolveComponent("imdex-select")!
  const _component_imdex_text_field = _resolveComponent("imdex-text-field")!
  const _component_imdex_btn = _resolveComponent("imdex-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("ssa.displayPane.thresholdFilterOptions.title")), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_imdex_spinner, {
                size: "2",
                width: "50"
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _withDirectives(_createVNode(_component_imdex_select, {
                value: _ctx.selectedLayerValue,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedLayerValue) = $event)),
                items: _ctx.layerItems,
                small: ""
              }, null, 8, ["value", "items"]), [
                [_vShow, _ctx.datasets[_ctx.activeView].dataType === ('Drillhole' as DatasetType)]
              ]),
              _hoisted_7,
              _createVNode(_component_imdex_select, {
                value: _ctx.selectedPropValue,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedPropValue) = $event)),
                items: _ctx.propItems,
                small: ""
              }, null, 8, ["value", "items"]),
              (
							_ctx.selectedLayerValue &&
							(!_ctx.activeLayerState?.fields ||
								Object.keys(_ctx.activeLayerState.fields).length === 0)
						)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createTextVNode(_toDisplayString(_ctx.$t("ssa.displayPane.thresholdFilterOptions.gettingProps")) + " ", 1),
                      _createVNode(_component_imdex_spinner, {
                        size: "2",
                        width: "25"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selectedPropValue)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (
								!(
									_ctx.existingActiveFilterInclHidden?.disableButDisplayFilter ||
									_ctx.existingActiveFilterInclHidden?.disableButDisplayFilterSlashEye
								) && !_ctx.activeSelectedProp?.isTimeStamp
							)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createVNode(_component_imdex_text_field, {
                            lazy: "",
                            small: "",
                            label: _ctx.$t('ssa.displayPane.min'),
                            type: "number",
                            onChange: _ctx.changeMin,
                            value: _ctx.activeMin,
                            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeMin) = $event))
                          }, null, 8, ["label", "onChange", "value"]),
                          _createVNode(_component_imdex_text_field, {
                            lazy: "",
                            small: "",
                            label: _ctx.$t('ssa.displayPane.max'),
                            type: "number",
                            onChange: _ctx.changeMax,
                            value: _ctx.activeMax,
                            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.activeMax) = $event))
                          }, null, 8, ["label", "onChange", "value"]),
                          _createVNode(_component_imdex_btn, {
                            onClick: _ctx.resetRange,
                            fab: "",
                            mini: "",
                            text: ""
                          }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : (
								!(
									_ctx.existingActiveFilterInclHidden?.disableButDisplayFilter ||
									_ctx.existingActiveFilterInclHidden?.disableButDisplayFilterSlashEye
								) && _ctx.activeSelectedProp?.isTimeStamp
							)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createVNode(_component_imdex_text_field, {
                              lazy: "",
                              small: "",
                              label: "Start Date",
                              type: "date",
                              onChange: _ctx.changeStartDate,
                              value: _ctx.startDate,
                              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.startDate) = $event))
                            }, null, 8, ["onChange", "value"]),
                            _createVNode(_component_imdex_text_field, {
                              lazy: "",
                              small: "",
                              label: "End Date",
                              type: "date",
                              onChange: _ctx.changeEndDate,
                              value: _ctx.endDate,
                              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.endDate) = $event))
                            }, null, 8, ["onChange", "value"]),
                            _createVNode(_component_imdex_btn, {
                              onClick: _ctx.resetRange,
                              fab: "",
                              mini: "",
                              text: ""
                            }, {
                              default: _withCtx(() => [
                                _hoisted_14
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]))
                        : (
								(_ctx.existingActiveFilterInclHidden?.disableButDisplayFilter ||
									_ctx.existingActiveFilterInclHidden?.disableButDisplayFilterSlashEye) &&
								_ctx.existingActiveFilterInclHidden &&
								_ctx.existingActiveFilterInclHidden.hiddenRangeValues &&
								_ctx.activeSelectedProp?.isTimeStamp
							)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createVNode(_component_imdex_text_field, {
                                lazy: "",
                                small: "",
                                label: "Start Date",
                                type: "date",
                                onChange: _ctx.changeStartDateFake,
                                value: _ctx.startDateFake,
                                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.startDateFake) = $event))
                              }, null, 8, ["onChange", "value"]),
                              _createVNode(_component_imdex_text_field, {
                                lazy: "",
                                small: "",
                                label: "End Date",
                                type: "date",
                                onChange: _ctx.changeEndDateFake,
                                value: _ctx.endDateFake,
                                "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.endDateFake) = $event))
                              }, null, 8, ["onChange", "value"]),
                              _createVNode(_component_imdex_btn, {
                                onClick: _ctx.resetRangeFake,
                                fab: "",
                                mini: "",
                                text: ""
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_16
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]))
                          : (
								(_ctx.existingActiveFilterInclHidden?.disableButDisplayFilter ||
									_ctx.existingActiveFilterInclHidden?.disableButDisplayFilterSlashEye) &&
								_ctx.existingActiveFilterInclHidden &&
								_ctx.existingActiveFilterInclHidden.hiddenRangeValues &&
								!_ctx.activeSelectedProp?.isTimeStamp
							)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createVNode(_component_imdex_text_field, {
                                  lazy: "",
                                  small: "",
                                  label: _ctx.$t('ssa.displayPane.min'),
                                  type: "number",
                                  onChange: _ctx.changeMinFake,
                                  value: _ctx.activeMinFake,
                                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.activeMinFake) = $event))
                                }, null, 8, ["label", "onChange", "value"]),
                                _createVNode(_component_imdex_text_field, {
                                  lazy: "",
                                  small: "",
                                  label: _ctx.$t('ssa.displayPane.max'),
                                  type: "number",
                                  onChange: _ctx.changeMaxFake,
                                  value: _ctx.activeMaxFake,
                                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.activeMaxFake) = $event))
                                }, null, 8, ["label", "onChange", "value"]),
                                _createVNode(_component_imdex_btn, {
                                  onClick: _ctx.resetRangeFake,
                                  fab: "",
                                  mini: "",
                                  text: ""
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_18
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]))
                            : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
      ])
    ])
  ]))
}